import { Routes, Route, Navigate } from "react-router-dom";
import { AppLayout } from "../AppLayout";
import HomePage from "./home/HomePage";
import LobbyPage from "./lobby/LobbyPage";
import SpacePage from "./space/SpacePage";
import { SpaceEntryRedirect } from "./space/SpaceEntryRedirect";
import PlatformOrdersPage from "./order/OrdersPage";
import PlatformBenefitsPage from "./benefits/BenefitsPage";
import CheckoutPage from "./order/CheckoutPage";
import OrderDetailPage from "./order/OrderDetailPage";
import LegalDocPage from "./legal/LegalDocPage";
import CreatorApplyPage from "./creator_apply/CreatorApplyPage";
import PlatformMyReportsPage from "./my-reports/MyReportsPage";

/** 龙粉社平台站路由（输入空间号进入） */
function PlatformApp() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/follows" element={<Navigate to="/" replace />} />
        <Route path="/subscriptions" element={<Navigate to="/" replace />} />
        <Route path="/orders" element={<PlatformOrdersPage />} />
        <Route path="/orders/:spaceId/:orderId" element={<OrderDetailPage />} />
        <Route path="/benefits" element={<PlatformBenefitsPage />} />
        <Route path="/my-reports" element={<PlatformMyReportsPage />} />
        <Route path="/lobby/:spaceId" element={<LobbyPage />} />
        <Route path="/space/:spaceId" element={<SpaceEntryRedirect />} />
        <Route path="/space/:spaceId/:section" element={<SpacePage />} />
        <Route path="/checkout/:spaceId/:orderId" element={<CheckoutPage />} />
        <Route path="/legal/:slug" element={<LegalDocPage />} />
        <Route path="/creator-apply" element={<CreatorApplyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default PlatformApp;
